export const features = [
  {
    title: "Fashion & Apparel Data Sheets",
    description: "Browse structured product tables covering clothing, footwear, and accessories from verified supplier networks with real-time price tracking.",
    icon: "ri-t-shirt-line",
  },
  {
    title: "Sneaker Comparison Tables",
    description: "Compare sneaker models side by side with detailed specifications, price history, and quality ratings in an easy-to-navigate spreadsheet format.",
    icon: "ri-footprint-line",
  },
  {
    title: "Electronics Price Tracking",
    description: "Monitor electronics pricing trends across categories with automated data refreshes and supplier reliability scores built into every sheet.",
    icon: "ri-smartphone-line",
  },
  {
    title: "Luxury Inspired Product Listings",
    description: "Discover curated luxury-inspired collections with transparent sourcing data, material breakdowns, and value assessment metrics.",
    icon: "ri-vip-diamond-line",
  },
  {
    title: "Budget Shopping Optimization",
    description: "Find the best value products within your budget using smart filtering, price-per-quality analysis, and seasonal trend forecasting.",
    icon: "ri-money-dollar-circle-line",
  },
  {
    title: "Supplier Trust Scoring",
    description: "Every supplier in our sheets receives a transparency score based on historical data consistency, helping you make informed decisions instantly.",
    icon: "ri-shield-check-line",
  },
];

export const valuePropositions = [
  "Compare thousands of products instantly across categories",
  "Identify high-quality suppliers with data-driven scoring",
  "Track price changes and seasonal trends in real time",
  "Avoid low-quality listings with structured quality metrics",
  "Make confident purchasing decisions backed by transparent data",
];